export default "__VITE_ASSET__C2494X37__"